import React, { useState, useEffect } from 'react';
import axios from 'axios';
////
import tasksJson from "../data/tasksJson.json";
import productsJson from "../data/productsJson.json";
import itemJson from "../data/itemJson.json";
////
import entitlements from "../data/entitlements.js";
import productCodes from "../data/productCodes.js";

import Help from "./Help";
import SvgComponent from "./SvgComponent";
import PopUp from "./PopUp";
////
import useApp from "../hook/useApp";
////
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
////
const GET_INVENTORY_ENTITLEMENTS = process.env.REACT_APP_GET_INVENTORY_ENTITLEMENTS;
const GET_PRODUCTS_LIST = process.env.REACT_APP_GET_PRODUCTS_LIST;
const PURCHASE_PRODUCT_VC = process.env.REACT_APP_PURCHASE_PRODUCT_VC;
const IS_AUTH_USER = process.env.REACT_APP_IS_AUTH_USER;
////
const TwoSection = () => {
    const { updatePropusk, updataData } = useApp();

    const get_inventory_entitlements = "https://tanki.su/wotup/claim_product/get_inventory_entitlements/"
    const get_products_list = "https://tanki.su/wotup/claim_product/get_products_list/"
    const purchase_product_vc = "https://tanki.su/wotup/claim_product/purchase_product_vc/"

    const tasksData = tasksJson;

    const [productsList, setProductsList] = useState(productsJson);

    const [item, setItem] = useState(itemJson);

    const [isId, setId] = useState([]);

    const [seconds, setSeconds] = useState(-1);
    const [isSum, setSum] = useState(false);
    const [isDop, setDop] = useState(0);
    const [hoverMarker, setHoverMarker] = useState(false);
    const [clickMarker, setClickMarker] = useState(false);
    const [clickHelmet, setClickHelmet] = useState(false);
    const [activeTask, setActiveTask] = useState(false);

    const [categoryOne, setCategoryOne] = useState(false);
    const [categoryTwo, setCategoryTwo] = useState(false);
    const [categoryThre, setCategoryThre] = useState(false);

    const [sendCode, setSendCode] = useState(false);

    const [isAuth, setAuth] = useState(false);

    useEffect(() => {
        if (window.wgcAuthInitPromise) {
            window.wgcAuthInitPromise
                .done(function () {
                    getEntitlements();
                });
        } else {
            getEntitlements();
        }
    }, [updataData]);

    const getEntitlements = () => {
        if ((IS_AUTH_USER === "true") ? true : Boolean(window.is_auth_user())) {
            setAuth(true)
            axios.post(GET_INVENTORY_ENTITLEMENTS, entitlements.data, {
                headers: {
                    'Content-Type': 'application/json',
                }
            })
                .then((response) => {
                    if (response.data.data.length !== 0) {
                        updatePropusk();
                        for (const task of tasksData) {
                            if (response.data.data.find(product => product.code === task.entitlementClaimed)) task.claimed = true;
                            if (response.data.data.find(product => product.code === task.entitlementComplited)) task.completed = true;
                        }
                    }

                    getProducts();
                }).catch((error) => {
                    toast.error("Ошибка, перезагрузите страницу.");
                }
                );
        } else {
            setAuth(false);
        }
    }

    const getProducts = () => {
        axios.post(GET_PRODUCTS_LIST, productCodes.data, {
            headers: {
                'Content-Type': 'application/json',
            }
        })
            .then((response) => {
                setProductsList(response.data)
            }).catch((error) => {
                toast.error("Ошибка, перезагрузите страницу.");
            }
            );
    }

    useEffect(() => {

        const sum = [];

        tasksData.map(x => {
            if (x.completed === true) {
                return sum.push(x.id);
            }
        })
        setSum(sum);

        for (const task of tasksData) {
            if (productsList.data.items.find(product => product.product_code === task.productCode)) task.desable = false;
        }

        const id = [];
        tasksData.map((x) => {
            if (x.claimed === true && x.completed === false) {
                for (const task of tasksData) {
                    if (tasksData.find(product => product.id !== x.id)) task.desable = true;
                }
                setActiveTask(x.id)
            }
            if (!x.desable && x.completed === false && !x.claimed) {
                id.push(x.id);
            }

            if (x.completed === true && x.id === 16) {
                setCategoryOne(true)
            }
            if (x.completed === true && x.id === 18) {
                setCategoryTwo(true)
            }
            if (x.completed === true && x.id === 17) {
                setCategoryThre(true)
            }

        });
        setId(id);

    }, [productsList]);

    useEffect(() => {

        if (activeTask === false) {
            function get_random(list) {
                return list[Math.floor((Math.random() * list.length))];
            }
            const timer = setInterval(() => {
                setSeconds(get_random(isId));
            }, 5000);
            return () => clearInterval(timer);
        } else {
            setSeconds(-1)
        }

    }, [isId, activeTask, productsList]);


    function uuidv4() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        }

    const startTask = (item) => {
        setSendCode(true)
        axios.post(PURCHASE_PRODUCT_VC,
            { "product_code": item.productCode, "language": "ru", "transaction_id": uuidv4(), "expected_prices": [{ "code": "sumfestbutaug", "amount": "1", "item_type": "entitlement" }] }, {
            headers: {
                'Content-Type': 'application/json',
            }
        })
            .then(() => {
                for (const task of tasksData) {
                    if (tasksData.find(product => product.id !== item.id)) task.desable = true;
                }

                setActiveTask(item.id);

                setSendCode(false)

            }).catch((err) => {
                setSendCode(false)
            });
    }

    return (
            <div className="c_section c_twoSection" id="c_twoSection">
                <div className="c_body">
                    <div className="c_images">

                        <img className='c_images__img' alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/sections/bg/2.png" />

                        <Help></Help>

                        <div className={isSum.length >= 12 ? "c_markers" : "c_markers c_markers__sum"}>
                            {tasksData.map((item) =>
                                <div
                                    className={item.desable && !item.completed && activeTask !== item.id ? "c_marker c_desable" : "c_marker"}
                                    id={activeTask !== item.id ? "" : "c_marker--active"}
                                >
                                    <img
                                        alt=""
                                        src={item.completed ? "https://tanki-media-content.tanki.su/ptl/sumfest/img/markers/icon/comlete.png" : item.icon}
                                        data-random-class={item.id === seconds ? "c_random-active" : ""}
                                        onMouseEnter={(e) => {
                                            setHoverMarker(true)
                                            setItem(item)
                                            if (isAuth) {
                                                if (activeTask) {
                                                    if (isSum.length <= 11) {
                                                        setDop(
                                                            item.id === activeTask ?
                                                                "0" : `${item.id === 16 || item.id === 17 || item.id === 18 ? "1" : `${item.completed ? "0" : "4"}`}`
                                                        )
                                                    }
                                                    if (isSum.length >= 12) {
                                                        setDop(
                                                            item.id === activeTask ?
                                                                "0" : `${item.completed ? "0" : `${item.completed ? "0" : "4"}`}`
                                                        )
                                                    }
                                                } else {
                                                    setDop(
                                                        isSum.length <= 11 ?
                                                            `${item.id === 16 || item.id === 17 || item.id === 18 ? "1" : "0"}` :
                                                            `${item.id === 16 || item.id === 17 || item.id === 18 ? "0" : "0"}`
                                                    )
                                                }
                                            }
                                            if (!isAuth) {
                                                setDop(`${item.id === 16 || item.id === 17 || item.id === 18 ? "1" : "3"}`)
                                            }
                                        }}
                                        onMouseOut={(e) => {

                                            setHoverMarker(false)
                                        }}
                                        onClick={(e) => {

                                            if (!item.desable && item.completed === false) {
                                                setItem(item)
                                                setClickMarker(true)
                                            }

                                            if (item.desable && activeTask === item.id) {
                                                setItem(item)
                                                setClickMarker(true)
                                            }

                                        }}
                                    />
                                    <img alt="" src={item.bg} />
                                </div>
                            )}
                        </div>

                        <div className={hoverMarker ? "c_notification c_notification-active" : "c_notification"}>
                            {item.completed && isDop === "0" ? (
                                <>
                                    <div className='c_notification__bg'>
                                        <img alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/all/small-pop-up-bg.png" />
                                    </div>
                                    <div className='c_notification__body'>
                                        <div className='c_notification__img'>
                                            <img alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/notifications/complete.png" />
                                        </div>
                                        <div className='c_notification__title'>
                                            <h3>ТИМУР:</h3>
                                        </div>
                                        <div className='c_notification__text'>
                                            <p>— Отличный результат, друг! Очередная задача пройдена. Ты на шаг ближе к успеху!</p>
                                        </div>
                                    </div>
                                </>
                            ) : ("")}

                            {!item.completed && isDop === "0" ? (
                                <>
                                    <div className='c_notification__bg'>
                                        <img alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/all/small-pop-up-bg.png" />
                                    </div>
                                    <div className='c_notification__body'>
                                        <div className='c_notification__img'>
                                            <img alt="" src={item.task.img} />
                                        </div>
                                        <div className='c_notification__title'>
                                            <h3>{item.task.title}</h3>
                                        </div>
                                        <div className='c_notification__text'>
                                            <p>{item.task.text}</p>
                                        </div>
                                    </div>
                                </>
                            ) : ("")}

                            {isDop === "1" ? (
                                <>
                                    <div className='c_notification__bg'>
                                        <img alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/all/small-pop-up-bg.png" />
                                    </div>
                                    <div className='c_notification__body'>
                                        <div className='c_notification__img'>
                                            <img alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/notifications/error.png" />
                                        </div>
                                        <div className='c_notification__title'>
                                            <h3>ТИМУР:</h3>
                                        </div>
                                        <div className='c_notification__text'>
                                            <p>— Я ценю твоё рвение, друг, но прежде, чем браться за эту задачу, необходимо закончить основной этап.</p>
                                        </div>
                                    </div>
                                </>
                            ) : ("")}

                            {isDop === "2" ? (
                                <>

                                    <div className='c_notification__bg'>
                                        <img alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/all/small-pop-up-bg.png" />
                                    </div>
                                    <div className='c_notification__body'>
                                        <div className='c_notification__img'>
                                            <img alt="" src={item.task.img} />
                                        </div>
                                        <div className='c_notification__title'>
                                            <h3>{item.task.title}</h3>
                                        </div>
                                        <div className='c_notification__text'>
                                            <p>{item.task.text}</p>
                                        </div>
                                    </div>
                                </>
                            ) : ("")}

                            {isDop === "3" ? (
                                <>
                                    <div className='c_notification__bg'>
                                        <img alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/all/small-pop-up-bg.png" />
                                    </div>
                                    <div className='c_notification__body'>
                                        <div className='c_notification__img'>
                                            <img alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/notifications/error.png" />
                                        </div>
                                        <div className='c_notification__title'>
                                            <h3>ТИМУР:</h3>
                                        </div>
                                        <div className='c_notification__text'>
                                            <p>— Я ценю твоё рвение, друг, но прежде, чем браться за выполнение задач необходимо войти на сайт игры!</p>
                                        </div>
                                    </div>
                                </>
                            ) : ("")}

                            {isDop === "4" ? (
                                <>
                                    <div className='c_notification__bg'>
                                        <img alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/all/small-pop-up-bg.png" />
                                    </div>
                                    <div className='c_notification__body'>
                                        <div className='c_notification__img'>
                                            <img alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/notifications/error.png" />
                                        </div>
                                        <div className='c_notification__title'>
                                            <h3>ТИМУР:</h3>
                                        </div>
                                        <div className='c_notification__text'>
                                            <p>— Я ценю ваше рвение, друг, но прежде, чем браться за новую задачу, нужно закончить предыдущую.</p>
                                        </div>
                                    </div>
                                </>
                            ) : ("")}

                        </div>


                        <div className={clickMarker ? "c_task__overlay c_task-active" : "c_task__overlay"}>
                            <img className="c_task__overlay-img" onClick={(e) => {
                                setClickMarker(false)
                            }} alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/all/overlay.png" />
                            <div className="c_task">
                                <div className="c_task__body">
                                    <div className="c_task__images">
                                        <img className={item.category === 1 ? "c_task__bg c_task__bg-active" : "c_task__bg"} alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/tasks/bg/1.png" />
                                        <img className={item.category === 2 ? "c_task__bg c_task__bg-active" : "c_task__bg"} alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/tasks/bg/2.png" />
                                        <img className={item.category === 3 ? "c_task__bg c_task__bg-active" : "c_task__bg"} alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/tasks/bg/3.png" />
                                    </div>
                                    <div className="c_task__content">
                                        <img className="c_task__img" alt="" src={item.task.img} />
                                        <div className="c_task__text">
                                            <h3 className='c_task__title'>{item.task.title}</h3>
                                            <p><strong>Условие:</strong> <br />
                                                {item.task.status}</p>
                                        </div>

                                        <div className='c_task__body-bottom'>

                                            <div className="c_task__lenta">
                                                <img className="c_task__lenta-img" alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/all/lenta.png" />
                                                <div className="c_task__icons">
                                                        {item.icons.map((itemIcon) =>
                                                            <div className="c_task__icon-item">
                                                                <img alt="" src={itemIcon.icon} />
                                                                <p>{itemIcon.text}</p>
                                                            </div>
                                                        )}
                                                </div>
                                            </div>
                                            <div className='c_btn__wrap'>


                                                {item.id === activeTask ? (
                                                    <>
                                                        <div className="c_btn" onClick={(e) => {
                                                            setClickMarker(false)
                                                        }}>
                                                            <img className="c_btn__img" alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/all/btn-default.png" />
                                                            <div
                                                                className="c_btn__text"

                                                            >
                                                                ТАК ТОЧНО!
                                                            </div>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <>
                                                        {sendCode ? (
                                                            <div className="c_btn">
                                                                <img className="c_btn__img" alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/all/btn-color.png" />
                                                                <div className="c_btn__text">
                                                                    Загрузка...
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div className="c_btn" onClick={(e) => {
                                                                startTask(item)
                                                                setClickMarker(false)
                                                            }}>
                                                                <img className="c_btn__img" alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/all/btn-color.png" />
                                                                <div className="c_btn__text">
                                                                    Принять
                                                                </div>
                                                            </div>
                                                        )}

                                                        <div className="c_btn" onClick={(e) => {
                                                            setClickMarker(false)
                                                        }}>
                                                            <img className="c_btn__img" alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/all/btn-default.png" />
                                                            <div
                                                                className="c_btn__text"

                                                            >
                                                                отклонить
                                                            </div>
                                                        </div>
                                                    </>
                                                )}

                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="c_timur">
                            <img className={hoverMarker ? "" : "c_timur-active"} alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/timur/2.png?ver=1.3vwe" />
                            <img className={hoverMarker && !item.completed ? "c_timur-active" : ""} alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/timur/3.png?ver=1.3vwe" />
                            <img className={hoverMarker && item.completed ? "c_timur-active" : ""} alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/timur/4.png?ver=1.3vwe" />
                        </div>

                        <div className="c_footer">
                            <div className="c_footer__one">
                                <div className="c_footer__line">
                                    <div className="c_footer__name">Знания</div>
                                    {tasksData.map((item) => item.category === 1 && item.completed === true ? <div key={item.id} className={`c_footer__item`}>
                                        <img alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/all/bar-1.png" />
                                    </div> : "")}
                                    <div className="c_footer__item-bg">
                                        <div className="c_footer__item">
                                            <img alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/all/bar-1.png" />
                                        </div>
                                        <div className="c_footer__item">
                                            <img alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/all/bar-1.png" />
                                        </div>
                                        <div className="c_footer__item">
                                            <img alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/all/bar-1.png" />
                                        </div>
                                        <div className="c_footer__item">
                                            <img alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/all/bar-1.png" />
                                        </div>
                                    </div>
                                </div>
                                <div className="c_footer__line">
                                    <div className="c_footer__name">Выдержка</div>
                                    {tasksData.map((item) => item.category === 2 && item.completed === true ? <div key={item.id} className={`c_footer__item`}>
                                        <img alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/all/bar-2.png" />
                                    </div> : "")}
                                    <div className="c_footer__item-bg">
                                        <div className="c_footer__item">
                                            <img alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/all/bar-2.png" />
                                        </div>
                                        <div className="c_footer__item">
                                            <img alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/all/bar-2.png" />
                                        </div>
                                        <div className="c_footer__item">
                                            <img alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/all/bar-2.png" />
                                        </div>
                                        <div className="c_footer__item">
                                            <img alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/all/bar-2.png" />
                                        </div>
                                    </div>
                                </div>
                                <div className="c_footer__line">
                                    <div className="c_footer__name">Сообразительность</div>
                                    {tasksData.map((item) => item.category === 3 && item.completed === true ? <div key={item.id} className={`c_footer__item`}>
                                        <img alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/all/bar-3.png" />
                                    </div> : "")}
                                    <div className="c_footer__item-bg">
                                        <div className="c_footer__item">
                                            <img alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/all/bar-3.png" />
                                        </div>
                                        <div className="c_footer__item">
                                            <img alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/all/bar-3.png" />
                                        </div>
                                        <div className="c_footer__item">
                                            <img alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/all/bar-3.png" />
                                        </div>
                                        <div className="c_footer__item">
                                            <img alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/all/bar-3.png" />
                                        </div>
                                    </div>
                                </div>

                                <div
                                    className="c_footer__two-bg"
                                    onClick={(e) => {
                                        setClickHelmet(true)
                                    }}
                                >
                                    {isSum.length >= 12 ? (
                                        <img alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/markers/icon/helmet-2.png?ver=24.65" />
                                    ) : (
                                        <img alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/markers/icon/helmet-1.png?ver=24.65" />
                                    )}
                                </div>
                            </div>
                            <div className="c_footer__two" >
                                <div className={categoryOne ? "c_footer__line c_footer__line--completed" : "c_footer__line"}>
                                    <div className="c_footer__item">
                                        <img alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/all/bar-1.png" />
                                        <span>
                                            {categoryOne ? (<SvgComponent color="#D53A34"></SvgComponent>) : ""}
                                        </span>
                                    </div>
                                </div>
                                <div className={categoryTwo ? "c_footer__line c_footer__line--completed" : "c_footer__line"}>
                                    <div className="c_footer__item">
                                        <img alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/all/bar-2.png" />
                                        <span>
                                            {categoryTwo ? (<SvgComponent color="#7C971D"></SvgComponent>) : ""}
                                        </span>
                                    </div>
                                </div>
                                <div className={categoryThre ? "c_footer__line c_footer__line--completed" : "c_footer__line"}>
                                    <div className="c_footer__item">
                                        <img alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/all/bar-3.png" />
                                        <span>
                                            {categoryThre ? (<SvgComponent color="#648F8F"></SvgComponent>) : ""}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="c_footer__bg">
                                <img alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/all/line.png" />
                            </div>
                        </div>

                        <div className={clickHelmet ? "c_task__overlay c_task-active c_helmet-pop-up" : "c_task__overlay c_helmet-pop-up"}>
                            <img
                                className="c_task__overlay-img"
                                alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/all/overlay.png"
                                onClick={(e) => {
                                    setClickHelmet(false)
                                }}
                            />
                            <div className="c_task">
                                <div className="c_task__body">
                                    <div className="c_task__images">
                                        <img className="c_task__bg c_task__bg-active" alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/tasks/bg/4.png" />
                                    </div>
                                    <div className="c_task__content">
                                        <div className="c_task__text">
                                            <p><strong>ПРАЗДНИЧНЫЙ 2D-СТИЛЬ</strong>
                                            Выполните 12 боевых задач, разбитых на три категории, чтобы полностью пройти прогрессию и заработать ценное игровое имущество.</p>
                                        </div>

                                        <div className='c_task__body-bottom'>

                                            <div className="c_task__lenta">
                                                <img className="c_task__lenta-img" alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/all/lenta.png" />
                                                <div className="c_task__icons">

                                                        <div className="c_task__icon-item">
                                                            <img alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/tasks/icons/19-1.png" />
                                                            <p>1 день Танкового премиум аккаунта</p>
                                                        </div>
                                                        <div className="c_task__icon-item">
                                                            <img alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/tasks/icons/19-2.png" />
                                                            <p>100 бон</p>
                                                        </div>
                                                        <div className="c_task__icon-item">
                                                            <img alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/tasks/icons/19-3.png" />
                                                            <p>2D-стиль «Наша игра (ночь)»</p>
                                                        </div>
                                                        <div className="c_task__icon-item">
                                                            <img alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/tasks/icons/19-4.png" />
                                                            <p>Демонтажные наборы</p>
                                                        </div>
                                                        <div className="c_task__icon-item">
                                                            <img alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/tasks/icons/19-5.png" />
                                                            <p>Задачи на х5 опыта за бой для любой техники</p>
                                                        </div>
                                                </div>
                                            </div>
                                            <div className='c_btn__wrap'>
                                                <div
                                                    className="c_btn"
                                                    onClick={(e) => {
                                                        setClickHelmet(false)
                                                    }}
                                                >
                                                    <img className="c_btn__img" alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/all/btn-color.png" />
                                                    <div className="c_btn__text">
                                                        ТАК ТОЧНО!
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
    );
};

export default TwoSection;